<template>
  <b-tab>
    <template v-slot:title>SMS Center</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View SMS Center</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_sms_center == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_sms_center')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_sms_center')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">SMS to Members</div>
          <div class="col-2">SMS to Staff</div>
          <div class="col-3">SMS to Others</div>
          <div class="col-3">Purchase Bundles</div> <!-- Added this -->
        </div>

        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- SMS to Members (Adjusted class to col-2) -->
          <div class="col-2">
            <RockerSwitch v-if="item.send_to_members == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'send_to_members')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'send_to_members')" />
          </div>

          <!-- SMS to Staff (Adjusted class to col-2) -->
          <div class="col-2">
            <RockerSwitch v-if="item.send_to_staff == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'send_to_staff')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'send_to_staff')" />
          </div>

          <!-- SMS to Others -->
          <div class="col-3">
            <RockerSwitch v-if="item.send_to_others == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'send_to_others')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'send_to_others')" />
          </div>

          <!-- Purchase Bundles -->
          <div class="col-3">
            <RockerSwitch v-if="item.purchase_bundles == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'purchase_bundles')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'purchase_bundles')" />
          </div>

        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "SmsPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_sms_center == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>